<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import utc from 'dayjs/plugin/utc'
import { useSports } from '~/composables/sports/use-sports'
import { DATE_TIME_FORMAT } from '~/constants'
import type { MatchData } from '~/utils/interface'

const BaseImage = defineAsyncComponent(async () => await import('~/components/common/base-image.vue'))

const { openKSportGame, playASportGame } = useSports()
dayjs.extend(customParseFormat)
dayjs.extend(utc)

const props = defineProps({
  item: {
    type: Object as () => MatchData
  },
  isNews: {
    type: Boolean,
    default: false
  }
})
const dateTimeConverted = dayjs.utc(props.item?.text_time?.trim(), DATE_TIME_FORMAT.FULL_DATE_FORMAT_SCHEDULE).local()
</script>
<template>
  <div class="hotmatch-item" :class="{ disabled: item?.isDisable }">
    <div class="hotmatch-item__ctn-infor-match">
      <div class="time-match">
        {{
          item?.isDisable
            ? '00:00'
            : dateTimeConverted.format(DATE_TIME_FORMAT.HOUR_MINUTE_DEFAULT)?.replace('Invalid Date', '--:--')
        }}
      </div>
      <div class="league-name line-limit-1">
        {{ item?.league_name }}
      </div>
      <div class="date-match">
        {{
          item?.isDisable
            ? '00/00'
            : dateTimeConverted.format(DATE_TIME_FORMAT.DAY_MONTH)?.replace('Invalid Date', '--/--')
        }}
      </div>
    </div>
    <div class="match-info">
      <div class="hotmatch-item__ctn-team">
        <div class="hotmatch-item__box-team">
          <BaseImage
            :src="item?.teams[0].flag_thumbnail"
            class="hotmatch-item__logo-team"
            imageDefault="/assets/images/common/no-item.png"
            :alt="item?.teams[0].name"
          />
          <div class="hotmatch-item__name line-limit-1 guest-team">
            {{ item?.teams[0].name }}
          </div>
        </div>
        <div class="hotmatch-item__box-team">
          <BaseImage
            :src="item?.teams[1].flag_thumbnail"
            class="hotmatch-item__logo-team"
            imageDefault="/assets/images/common/no-item.png"
            :alt="item?.teams[1].name"
          />
          <div class="hotmatch-item__name line-limit-1">
            {{ item?.teams[1].name }}
          </div>
        </div>
      </div>
      <div class="hotmatch-item__ctn-bet">
        <div class="hotmatch-item__ctn-rate">
          <div :class="['text-odds', `${Number(item?.hTeam?.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.hTeam?.odds || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.hTeam?.rate) < 0 ? 'align-left' : ''}`]">
            {{ item?.hTeam?.rate || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.aTeam?.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.aTeam?.odds || '-' }}
          </div>
        </div>
        <div class="text-bet">Chấp</div>
        <div class="hotmatch-item__ctn-rate">
          <div :class="['text-odds', `${Number(item?.athena_ahFT?.hTeam.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.athena_ahFT?.hTeam.odds || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.athena_ahFT?.hTeam.rate) < 0 ? 'align-left' : ''}`]">
            {{ item?.athena_ahFT?.hTeam.rate || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.athena_ahFT?.aTeam.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.athena_ahFT?.aTeam.odds || '-' }}
          </div>
        </div>
      </div>
      <div class="hotmatch-item__ctn-bet">
        <div class="hotmatch-item__ctn-rate">
          <div :class="['text-odds', `${Number(item?.overFT?.hTeam.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.overFT?.hTeam.odds || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.overFT?.hTeam.rate) < 0 ? 'align-left' : ''}`]">
            {{ item?.overFT?.hTeam.rate || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.overFT?.aTeam?.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.overFT?.aTeam?.odds || '-' }}
          </div>
        </div>
        <div class="text-bet">Tài xỉu</div>
        <div class="hotmatch-item__ctn-rate">
          <div :class="['text-odds', `${Number(item?.athena_overFT?.hTeam.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.athena_overFT?.hTeam.odds || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.athena_overFT?.hTeam.rate) < 0 ? 'align-left' : ''}`]">
            {{ item?.athena_overFT?.hTeam.rate || '-' }}
          </div>
          <div :class="['text-odds', `${Number(item?.athena_overFT?.aTeam.odds) > 0 ? 'win' : 'lose'}`]">
            {{ item?.athena_overFT?.aTeam.odds || '-' }}
          </div>
        </div>
      </div>
      <div class="hotmatch-item__ctn-btn-sports">
        <button
          class="btn-hotmatch btn-k-sport"
          :disabled="item?.isDisable || !item?.overFT"
          :class="{ disabled: item?.isDisable || !item?.overFT }"
          @click.prevent="openKSportGame(item)"
        >
          K-Sports
        </button>
        <button
          class="btn-hotmatch btn-a-sport"
          :disabled="item?.isDisable || !item?.athena_ahFT"
          :class="{ disabled: item?.isDisable || !item?.athena_ahFT }"
          @click.prevent="playASportGame(item)"
        >
          A-Sports
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~scssAsset/mobile/sports/hot-match-item-news.scss';
</style>
